import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { CheckCircle, Package, ArrowRight } from "lucide-react";

const STEPS = [
  "You'll receive an email confirmation shortly.",
  "Our team will process and carefully pack your order.",
  "Your fragrance will be delivered to your address.",
];

export default function OrderSuccess() {
  const { state } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen bg-brand-cream flex items-center justify-center px-4 py-24">
      <div className={`text-center max-w-lg w-full transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        {/* Icon */}
        <div className="w-24 h-24 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-8">
          <CheckCircle size={48} className="text-green-500" />
        </div>

        <h1 className="font-display text-5xl text-brand-dark font-light mb-3">Order Confirmed!</h1>

        <p className="font-body text-gray-500 leading-relaxed">
          {state?.customerName ? `Thank you, ${state.customerName.split(" ")[0]}! ` : "Thank you! "}
          Your order has been received and is being processed.
        </p>

        {/* Reference */}
        {state?.reference && (
          <div className="inline-block mt-5 mb-8 px-6 py-4 bg-white rounded-sm border border-gray-100 shadow-sm">
            <p className="font-body text-[10px] text-gray-400 uppercase tracking-widest mb-1">Payment Reference</p>
            <p className="font-body font-semibold text-brand-charcoal">{state.reference}</p>
          </div>
        )}

        {/* Next steps */}
        <div className="bg-white p-6 rounded-sm mb-8 text-left shadow-sm">
          <div className="flex items-center gap-2 mb-5">
            <Package size={15} className="text-brand-red" />
            <p className="font-body text-xs font-semibold text-brand-charcoal uppercase tracking-widest">What happens next?</p>
          </div>
          {STEPS.map((step, i) => (
            <div key={i} className="flex gap-3 items-start py-2">
              <span className="w-5 h-5 bg-brand-cream rounded-full flex items-center justify-center font-body text-xs text-brand-red font-bold shrink-0 mt-0.5">{i + 1}</span>
              <p className="font-body text-sm text-gray-500">{step}</p>
            </div>
          ))}
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" className="btn-primary">Back to Home</Link>
          <Link to="/products" className="btn-outline group">
            Shop More <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </div>
  );
}
